export class DatepickerManager {
  static initialize() {
    try {
      this.initializeDatepickers()
    } catch (error) {
      console.error('Error initializing datepickers:', error)
    }
  }

  static initializeDatepickers() {
    const elements = document.querySelectorAll('[data-datepicker]')
    
    elements.forEach((element, index) => {
      // Skip if already initialized
      if (!element._datepicker) {
        const format = element.getAttribute('data-datepicker-format') || 'mm/dd/yyyy'
        
        if (typeof window.Datepicker !== 'undefined') {
          try {
            
            const options = {
              format: format,
              autohide: true,
              todayHighlight: true,
              orientation: 'bottom',
              todayBtn: false,
              clearBtn: false
            }
            
            const datepicker = new window.Datepicker(element, options)
            
            // Store reference on element
            element._datepicker = datepicker
            
            // Override the buggy hide method in Flowbite
            const originalHide = datepicker.hide.bind(datepicker)
            datepicker.hide = function() {
              originalHide()
              // Fix the CSS classes that Flowbite messes up
              if (this.picker && this.picker.element) {
                this.picker.element.classList.remove('active', 'block')
                this.picker.element.classList.add('hidden')
              }
            }
          } catch (error) {
            console.error(`Error initializing datepicker for element ${index}:`, element, error)
          }
        }
      }
    })
  }
  
  static destroy(element) {
    if (element._datepicker) {
      // Destroy the datepicker instance
      element._datepicker.destroy()
      delete element._datepicker
    }
  }
} 